import { render, staticRenderFns } from "./AssignSchemas.vue?vue&type=template&id=1adfe23c&"
import script from "./AssignSchemas.vue?vue&type=script&lang=js&"
export * from "./AssignSchemas.vue?vue&type=script&lang=js&"
import style0 from "./AssignSchemas.vue?vue&type=style&index=0&id=1adfe23c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports